import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';
import {interpret} from 'dictionary';

class OptimizeButton extends Component {
    onClick() {
        this.props.dispatch(Action.get('Lineups', false));
    }

    getLabel() {
        const {sportConfig} = this.props;

        if (sportConfig.isModeLateswap()) {
            return interpret('RE-OPTIMIZE');
        }

        return interpret('OPTIMIZE');
    }

    render() {
        const {optimization} = this.props;
        const activeClass = optimization.isRunning() ? 'active' : '';

        return (
            <button
                type="button"
                {...(!optimization.isRunning() && {onClick: () => ::this.onClick()})}
                className={`calculate-lineups btn ${activeClass}`}
            >
                {this.getLabel()}
            </button>
        );
    }
}

function mapStatesToProps(state) {
    const {optimization, sportConfig} = state;

    return {
        optimization,
        sportConfig,
    };
}

export default connect(mapStatesToProps)(OptimizeButton);
